import React from 'react';
import PropTypes from 'prop-types';
import Loader from './loader.jsx';

/**
 * Renders a loading box, which is a wrapper containing a loading icon (ellipsis).
 */
const LoadingBox = ({ className }) => {
  let classList = 'loading-box';

  if (className) {
    classList += ` ${className}`;
  }

  return (
    <div className={classList} data-testid='loading-box'>
      <Loader />
    </div>
  );
}

LoadingBox.propTypes = {
  /**
   * additional classes to add to the loading box
   */
  className: PropTypes.string,
};

export default LoadingBox;
